import { ApolloClient, InMemoryCache } from '@apollo/client/core/core.cjs';

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

const client = new ApolloClient({
  uri:
    import.meta.env.PUBLIC_GRAPHQL_API_ENDPOINT ||
    'http://localhost:5001/v1/graphql',
  cache: new InMemoryCache(),
});

export const getConfiguredApolloClient = (headers) => {
  return new ApolloClient({
    uri:
      import.meta.env.PUBLIC_GRAPHQL_API_ENDPOINT ||
      'http://localhost:5001/v1/graphql',
    cache: new InMemoryCache(),
    headers,
    defaultOptions: defaultOptions,
  });
};

export default client;
